var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack6Solid14({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82,3.91H7.73a5.76,5.76,0,0,1,1.5.15,2.72,2.72,0,0,1,1.18.72,3.63,3.63,0,0,1,.76,1.28,5.85,5.85,0,0,1,.25,1.86,5.23,5.23,0,0,1-.24,1.68A3.5,3.5,0,0,1,10.34,11a2.81,2.81,0,0,1-1.12.63,4.88,4.88,0,0,1-1.41.16h-3ZM6.41,5.24v5.22H7.6a4.3,4.3,0,0,0,1-.08,1.35,1.35,0,0,0,.64-.33,1.63,1.63,0,0,0,.42-.76,5,5,0,0,0,.16-1.44,4.58,4.58,0,0,0-.16-1.4,1.81,1.81,0,0,0-.45-.76,1.45,1.45,0,0,0-.74-.37,7.06,7.06,0,0,0-1.3-.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack6Solid14);
export default __webpack_public_path__ + "static/media/Symbolpack_6_solid_14.591c74b745dd822a999aeb89f7d488e5.svg";
export { ForwardRef as ReactComponent };